// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"AvisosSuspension__tabsContainer__18NMU"};